import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { buildBlockedSignInStatusState } from "../utils/auth/interceptedAccess";
import { buildLaunchSearch, getEffectiveLaunchContext } from "../utils/auth/intent";

const CompetitorVideoPage = () => {
    const location = useLocation();
    const launchContext = getEffectiveLaunchContext(location.search);

    return (
        <Navigate
            to={`/auth-status${buildLaunchSearch(launchContext) || ""}`}
            replace
            state={buildBlockedSignInStatusState(location.state?.access, {
                intent: launchContext.intent,
            })}
        />
    );
};

export default CompetitorVideoPage;
